import { GraphQLClient } from 'graphql-request'
import { GRAPHQL_HOST } from 'src/config/config'

import { getSdk } from './generated/requests'

export const apolloSdk = getSdk(new GraphQLClient(GRAPHQL_HOST!))
